import {FC} from "react";
import {toAbsoluteUrl} from "../../../../../_kiloit/helpers";
import {useAppSelector} from "../../../../redux/hooks/hook";
import clsx from "clsx";


const SOCountDownTimer: FC<{ countDown: number }> = ({countDown}) => {
    if (countDown < 0) return null;
    return <div id="timer-countdown" className={clsx("countdown-time-wrapper", {"sec10": countDown <= 9})}>
        <div className={clsx("countdown-time-num")}>
            {countDown}
        </div>
        <div className="img-countdown-time"></div>
        <div className="img-loading-countdown-time"></div>
    </div>
}
const DrawingResult: FC<{ tableId: number }> = ({tableId}) => {
    const countDown = useAppSelector(state => state.gameState.game.countDown);

    return <div className="drawing-result d-flex align-items-center position-relative">
        <SOCountDownTimer countDown={countDown}/>
        <img className="img-table" src={toAbsoluteUrl(`/media/socdia/tables/${tableId}.jpg`)} alt="__"/>
        <div className="cd-animate-wrap">
            {/*<div className="btn_BKCDprompt"></div>*/}
            <div id="cd_animate_box" className="cd-animate-box">
                <div id="cd_animate_order_order" className="cd-animate-order">
                    <img id="cd_cover" className="cd-cover" src={toAbsoluteUrl("/media/socdia/img_cover.png")}
                         alt="cd-cover"/>
                    <img id="cd_colordish" className="cd-colordish"
                         src="" alt=""/>
                    <img id="cd_dish" className="cd-dish" src={toAbsoluteUrl("/media/socdia/img_dish.png")}
                         alt="cd-dish"/>
                </div>
            </div>
        </div>
    </div>
}

export {DrawingResult}